import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './landing.css';

// Prevent browser from restoring random scroll positions on reload
if (typeof window !== 'undefined') {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Fatal: root element "#root" not found in DOM.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
